module.exports = __webpack_public_path__ + "img/no_caddy.c6dd4b25.png";